import { useState } from 'react';
import ServiceCleaning from './Service/ServiceCleaning';
import ServiceSettlement from './Service/ServiceSettlement';
import ServiceRefill from './Service/ServiceRefill';
import ServiceTakeBack from './Service/ServiceTakeBack';
import ServiceInventory from './Service/ServiceInventory';
import ServicePacklist from './Service/ServicePacklist';
import ServiceTubes from './Service/ServiceTubes';
import ServiceSales from './Service/ServiceSales';
import ServiceChangeRestock from './Service/ServiceChangeRestock';
import ServiceGeneral from './Service/ServiceGeneral';

export default function TourMachine(props) {

  let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  const sorter = (sortBy) => (a, b) => a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;
  const [chosenService, setChoseService] = useState();
  const [canContinue, setCanContinue] =useState(false);

  const chooseService = (service) => {
    setChoseService(service);
    if(ServiceTypeViews[service.type].props.needsExtraData==false){
      setCanContinue(true);
    }
    else if(service.extraData!==undefined && service.extraData.length>0 ){
      setCanContinue(true);
    }
    else setCanContinue(false);
  }

  const clearService = () => {
    setChoseService(null);
    setCanContinue(false);
  }

  const nextService = () => {
    let nextServiceCandidate = null;
    let currentServiceFound = false;
    Object.entries(props.machine.services).forEach(([key, service]) => {
      if (!currentServiceFound) {
        if (service === chosenService) currentServiceFound = true;
        return;
      }
      if (service.execution_tstamp != null || service.cancel_tstamp != null) return;
      if (nextServiceCandidate === null) nextServiceCandidate = service;
    });
    //check if everything is done
    let allDone = true;
    Object.entries(props.machine.services).forEach(([key, service]) => {
      if (service.execution_tstamp == null && service.cancel_tstamp == null) allDone = false;
    });
    props.machine.allServicesDone = allDone;
    if (allDone) {
      props.clearMachine(true);
    }
    else {
      setChoseService(nextServiceCandidate);
      if(nextServiceCandidate!==null){
        if(ServiceTypeViews[nextServiceCandidate.type].props.needsExtraData==false){
          setCanContinue(true);
        }
        else if(nextServiceCandidate.extraData!==undefined && nextServiceCandidate.extraData.length>0 ){
          setCanContinue(true);
        }
        else setCanContinue(false);
      }
    }
  }

  const finishService = () => {
    let date = new Date();
    chosenService.execution_tstamp = date.toISOString();
    chosenService.cancel_tstamp = null;
    props.setServiceQueue(chosenService);
    nextService();
  }

  const cancelService = () => {
    let date = new Date();
    chosenService.execution_tstamp = null;
    chosenService.cancel_tstamp = date.toISOString();
    props.setServiceQueue(chosenService);
    nextService();
  }

  const updateExtraData = (data) => {
    chosenService.extraData = data;
    if(data!==undefined){
      if(data instanceof Array && data.length>0){
        setCanContinue(true);
      }
      else{
        let dataArray=Object.values(data);
        let containsData=false;
        if(dataArray.length>0){
          dataArray.forEach((element)=> {if(element!==undefined && element!='')containsData=true;});
        }
        setCanContinue(containsData);
      }
    }
    const productServiceTypes = ['refill', 'take back', 'inventory'];
    if (productServiceTypes.includes(chosenService.type)) {
      props.machine.productData = data;
    }
    props.setMachineExtraData(props.machine);
    setChoseService(chosenService);
  }

  let ServiceTypeIcons = {
    'refill': 'cart plus icon',
    'take back': 'cart arrow down icon',
    'inventory': 'clipboard list icon',
    'cleaning': 'tint icon',
    'filter exchange': 'recycle icon',
    'change restock': 'coins icon',
    'settlement': 'cash register icon',
    'technical': 'screwdriver icon',
    'general': 'screwdriver icon',
    'measurement': 'thermometer half icon'
  }

  let ServiceTypeViews = {
    'packlist': <ServicePacklist service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} clearService={clearService} updateExtraData={updateExtraData} spontaneous={props.spontaneous ?? false} userOptions={props.userOptions} />,
    'tubes': <ServiceTubes service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} clearService={clearService} updateExtraData={updateExtraData} spontaneous={props.spontaneous ?? false} userOptions={props.userOptions} />,
    'sales': <ServiceSales service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} clearService={clearService} updateExtraData={updateExtraData} spontaneous={props.spontaneous ?? false} userOptions={props.userOptions} />,
    'cleaning': <ServiceCleaning service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'general': <ServiceGeneral service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'inventory': <ServiceInventory service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} spontaneous={props.spontaneous ?? false} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'refill': <ServiceRefill service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'settlement': <ServiceSettlement service={chosenService} needsExtraData={true} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'take back': <ServiceTakeBack service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />,
    'change restock': <ServiceChangeRestock service={chosenService} needsExtraData={false} machine={props.machine} machineType={props.machineType} finishService={finishService} cancelService={cancelService} updateExtraData={updateExtraData} userOptions={props.userOptions} />
  }

  let packService = { 'type': 'packlist', 'name': 'Packliste', 'execution_tstamp': null, 'cancel_tstamp': null };
  let tubeService = { 'type': 'tubes', 'name': 'Tuben', 'execution_tstamp': null, 'cancel_tstamp': null };
  let salesService = { 'type': 'sales', 'name': 'Verkäufe', 'execution_tstamp': null, 'cancel_tstamp': null };

  let content;
  if (chosenService == null) {
    const items = props.machine.services.map(service => <div className="event" onClick={() => chooseService(service)}>
      <div className="label"><i className={(service.execution_tstamp === null ? (service.cancel_tstamp === null ? "" : "red") : "green") + " " + (ServiceTypeIcons[service.type] ?? 'wrench icon')}></i></div>
      <div className="content">
        <div className="summary">
          <a className="header">{service.name}</a>
          {
            (service.execution_tstamp === null ? (service.cancel_tstamp === null ? "" :
              <div className="date">
                <i className='times icon'></i> {new Date(service.cancel_tstamp).toLocaleTimeString()}
              </div>

            ) :
              <div className="date">
                <i className='check icon'></i> {new Date(service.execution_tstamp).toLocaleTimeString()}
              </div>
            )

          }
        </div>
      </div>
    </div>);

    let sortedBestBeforeData = [];
    if(props.machine.productData!==undefined && props.machine.productData!==null){
      Object.entries(props.machine.productData).forEach(([pkey, product]) => {
        if(product.best_before == null || new Date(product.best_before) >= new Date().setDate(new Date().getDate()+7))return;
        sortedBestBeforeData.push(product);
      });
    }
    if(sortedBestBeforeData.length>0){
      sortedBestBeforeData.sort(sorter('best_before'));
    }

    const tubeContent = props.machine.missingCoinCount<25 ? '' : props.machine.missingCoins.map(coin=> <div className='item'><div className="content"><div className='header'>{Euro.format(coin.coin*0.01)}</div><div className='description'>{coin.missing_amount}x befüllen (Soll: {Math.min(coin.desired_amount,coin.max_amount)})</div></div></div>);

    const bestBeforeContent = sortedBestBeforeData.length==0 ? '' : sortedBestBeforeData.map(product=> <div className='item'><div className="content"><div className='header'>{product.name}</div><div className='description'><span className={'ui text '+(new Date(product.best_before) <= new Date() ? 'error' : 'warning')}>{new Date(product.best_before).toLocaleDateString()}</span></div></div></div>);
    content = <div>
      <h3 className="ui inverted block header"><i className="chevron left icon" onClick={props.clearMachine}></i>Automat {props.machine.serial_number}</h3>
      <div className="ui equal width grid">
        <div className="row">
          <div className="column">
            <i className="info icon"></i> {props.machine.device_number}<br />
            <i className="marker icon"></i> {props.machine.type_name}
          </div>
          <div className="column">
            <i className="donate icon"></i> {(props.machine.last_sale==null ? '---' : new Date(props.machine.last_sale).toLocaleString())}<br />
            <i className="wifi icon"></i> {(props.machine.last_contact==null ? '---' : new Date(props.machine.last_contact).toLocaleString())}
          </div>
        </div>
        <div className="row">
          <div className="column">
            <a onClick={e => chooseService(packService)}><i className='clipboard list icon'></i> Packliste</a><br />
          </div>
          <div className="column">
            <a onClick={e => chooseService(tubeService)}><i className='coins icon'></i> Tuben</a><br />
          </div>
          <div className="column">
            <a onClick={e => chooseService(salesService)}><i className='shopping basket icon'></i> Verkäufe</a><br />
          </div>
        </div>
      </div>
      {
        bestBeforeContent=='' ? '' : 
          <div>
            <div className='ui divider'></div>
            <h4>MHD</h4>
            <div className="ui list">{bestBeforeContent}</div>
          </div>
      }
      {
        tubeContent=='' ? '' :
         <div>
            <div className='ui divider'></div>
            <h4>Wechselgeld</h4>
            <div className="ui list">{tubeContent}</div>
          </div>
      }
      <div className='ui divider'></div>
      <div className="ui connected feed">{items}</div>
    </div>
  }
  else {
    switch(chosenService.type){
      case 'packlist':
        content=<div>
          <h3 className="ui inverted block header"><i className="chevron left icon" onClick={clearService}></i> {chosenService.name} "{props.machine.serial_number}"</h3>
          {ServiceTypeViews['packlist']}
        </div>
        break;
      case 'sales':
        content=<div>
          <h3 className="ui inverted block header"><i className="chevron left icon" onClick={clearService}></i> {chosenService.name} "{props.machine.serial_number}"</h3>
          {ServiceTypeViews['sales']}
        </div>
        break;
      case 'tubes':
        content=<div>
          <h3 className="ui inverted block header"><i className="chevron left icon" onClick={clearService}></i> {chosenService.name} "{props.machine.serial_number}"</h3>
          {ServiceTypeViews['tubes']}
        </div>
        break;
      default:
        const serviceList = props.machine.services.map(service => <div className="item" onClick={() => chooseService(service)}>
        <i className={(service === chosenService ? "primary" : (service.execution_tstamp === null ? (service.cancel_tstamp === null ? "" : "red") : "green")) + " " + (ServiceTypeIcons[service.type] ?? 'wrench icon')}></i>
      </div>);
      content = <div>
        <h3 className="ui inverted block header"><i className="chevron left icon" onClick={clearService}></i> {chosenService.name} "{props.machine.serial_number}"</h3>
        <div className="ui huge ordered horizontal list service-list">
          {serviceList}
        </div>
        <div className='ui divider'></div>
        <div>
          {ServiceTypeViews[chosenService.type] ?? 'work in progress'}
          <br />
          <div className="ui two spaced buttons">
            <button className='ui negative labeled icon button' onClick={cancelService}><i className="times icon"></i> Storno</button>
            <button className={(canContinue ? '' : 'disabled ')+'ui positive labeled icon button'} onClick={finishService}><i className='check icon'></i> OK</button>
          </div>
        </div>
      </div>
      break;
    }
  }

  return (
    <div>

      {content}
    </div>
  );
}